export default __webpack_public_path__ + "static/media/banner-thumb.a0fdb6c8.png";